<template lang="pug">
  InfoPage(:title="title" :content="$t(pageContent)")
</template>

<script>
import InfoPage from '~/components/InfoPage/InfoPage'
import Info from '~/mixins/Info'

export default {
  name: 'PageInfoRiskDisclosure',
  components: { InfoPage },
  mixins: [Info],
  data () {
    return { title: this.$t('riskDisclosure') }
  }
}
</script>
